import { SERVICES } from '@/data/site';
import { SectionHeader } from './SectionHeader';
import { ServiceCard } from './ServiceCard';
import { Reveal } from './Reveal';

export const Services = () => (
  <section aria-labelledby="services-heading" data-testid="services-section" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="01"
        eyebrow="Our Services"
        title="One brand. Four service lines."
        description="We deliver practical, hands-on support across every aspect of your business."
        testid="services-header"
      />

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((service, i) => (
          <Reveal key={service.id} delay={i * 0.08} className="h-full">
            <ServiceCard
              name={service.name}
              color={service.color}
              description={service.description}
              areas={service.areas}
              href={service.href}
              testid={`service-card-${service.id}`}
              linkTestid={`service-learn-more-${service.id}`}
            />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
